import { render, staticRenderFns } from "./buyNow.vue?vue&type=template&id=28a0f74e&scoped=true"
import script from "./buyNow.vue?vue&type=script&lang=js"
export * from "./buyNow.vue?vue&type=script&lang=js"
import style0 from "./buyNow.vue?vue&type=style&index=0&id=28a0f74e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a0f74e",
  null
  
)

export default component.exports